import React from "react";
import styled from "styled-components";
import iconAttempt from "../../../../../../assets/images/Mini-Game/attempt-coin.svg";
import bgButtonChange from "../../../../../../assets/images/Mini-Game/bg-button-change.png";
import { useDispatch } from "react-redux";
import { setOpenPopupFooter } from "../../../../../../Redux/futures/mini-game/action";
import { useTranslation } from "react-i18next";

export default function ChangeCoins({
  handleConfirm,
  setStep,
  turn,
  isNoMoreCoins = false,
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const handleCancelDefault = () => {
    if (isNoMoreCoins) {
      setStep("earn more");
    } else {
      dispatch(
        setOpenPopupFooter({
          isShowPopup: false,
          step: "",
          turn: 0,
        })
      );
    }
  };


  return (
    <Container>
      <div className='mini-change-coins-header'>{t("mini_game.standard_missions.1_turn_1_coin")}</div>
      <div className='mini-icon-change'>
        <img src={iconAttempt} alt='' height={150} style={{ height: "150px", display: "flex", justifyContent: "center", margin: "0 auto" }} />
      </div>
      <div className='mini-change-coins-header'>{t("mini_game.pop_up_change_turns.you_want_to_change")}</div>
      <div className='total-mini-change'>
        {+turn !== 1
          ? `${turn} coins (-${turn} turns)`
          : `${turn} coin (-${turn} turn)`}
      </div>
      <div className='change-footer'>
        <div className='btn-confirm-change' onClick={handleConfirm}>
          <img
            src={bgButtonChange}
            alt=''
            className='btn-confirm-change__mini'
          />
          <div className='content'>{t("mini_game.pop_up_change_turns.confirm")}</div>
        </div>
        <div
          className='btn-cancel-change'
          onClick={handleCancelDefault}
        >
          {t("mini_game.pop_up_change_turns.cancel")}
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  .btn-cancel-change {
    font-size: 16px;
    text-align: center;
    margin-top: 25px;
    font-weight: 500;
  }
  .btn-confirm-change {
    position: relative;
    margin-top: 40px;
    text-align: center;

    .btn-confirm-change__mini {
      min-height: 42px;
      padding: 0 20px;
    }

    .content {
      position: absolute;
      z-index: 2;
      top: calc(50% - 3px);
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .mini-change-coins-header {
    font-size: 18px;
    color: #954911;
    text-align: center;
    font-weight: 500;
  }

  .total-mini-change {
    font-weight: bold;
    font-size: 24px;
    color: #954911;
    text-align: center;
  }

  .mini-icon-change {
    text-align: center;
    padding: 16px 0;
  }

  @media (min-width: 992px) {
    .btn-confirm-change,
    .btn-cancel-change {
      &:hover {
        cursor: pointer;
        scale: 1.02;
        transition: 0.3s ease-in-out;
      }
    }
  }
`;
